import { Button, Text } from '@chakra-ui/react'

import ModalV3 from '@/components/UI/Modal/ModalV3'

import type { ModalState } from './types'

export default function AppContextModalPendingApproval({
  modalState,
  hideModal,
}: {
  modalState: ModalState | null
  hideModal: () => void
}): React.ReactElement {
  return (
    <ModalV3
      open
      onClose={hideModal}
      title="Your account is pending approval"
      body={() => (
        <Text>
          Our team needs to approve your account before you can {modalState?.actionName}. Hang
          tight!
        </Text>
      )}
      rightFooterContent={() => <Button onClick={hideModal}>Got it!</Button>}
    />
  )
}
